module.exports = __webpack_public_path__ + "img/24.2b0b42e8.webp";